const Title = ({ title }) => {
  return (
    <span className="text-headingCardsMobile xl:text-headingCardsDesktop text-background font-ttDrugsTrial uppercase">
      {title}
    </span>
  )
}

export default Title
